<template>
  <div class="eventList">
    <v-row no-gutters justify="center">
      <v-col class="py-0">
        <v-row no-gutters class="py-0">
          <v-col class="pa-3">
            <v-row no-gutters>
              <v-col class="py-0">
                <v-row no-gutters justify="center" class="contentEventList">
                  <v-expansion-panels
                    v-if="userEventList == 0"
                    accordion
                    multiple
                    :value="[0]"
                  >
                    <v-expansion-panel v-for="(item,i) in menu" :key="i">
                      <v-expansion-panel-header
                        class="my-1"
                        color="accent"
                      >
                        <p
                          depressed
                          class="font-weight-bold text-left text-uppercase text-customizer-exp"
                        >{{ item.name }}</p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <component :is="item.component"></component>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-expansion-panels
                    v-if="userEventList > 0"
                    accordion
                    multiple
                    :value="[0]"
                  >
                    <v-expansion-panel v-for="(item,i) in menu" :key="i">
                      <v-expansion-panel-header
                        class="my-1"
                        color="accent"
                      >
                        <p
                          depressed
                          class="font-weight-bold text-left text-uppercase text-customizer-exp"
                        >{{ item.name }}</p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <component :is="item.component"></component>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Current from "@/components/dashboard/eventList/Current.vue";
import Past from "@/components/dashboard/eventList/Past.vue";
import Import from "@/components/dashboard/eventList/Import.vue";
import Delete from "@/components/dashboard/eventList/Delete.vue";
import { apiCalls } from "@/mixins/apiCalls.js";
import AsyncComputed from "vue-async-computed";
import Vue from "vue";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  components: {
    Current,
    Past,
    Import,
    Delete
  },
  data() {
    return {
      navigationBGColor: "#FFF",
      userEventList: null
    };
  },
  computed: {
    menu() {
      return [
        {
          name: this.$t("dashboard.menu.current.name"),
          component: "Current"
        },
        {
          name: this.$t("dashboard.menu.past"),
          component: "Past"
        },
        {
          name: this.$t("dashboard.menu.import"),
          component: "Import"
        },
        {
          name: this.$t("dashboard.menu.delete"),
          component: "Delete"
        }
      ];
    }
  },
  asyncComputed: {
    userEventList: async function() {
      const response = await this.api(
        "get",
        "/api/v1/users/current/getUserEventList/curE"
      );

      return response.message.length;
    }
  },
  created: function() {
    this.navigationBGColor = "#ccc";
  }
};
</script>
<style lang="scss">
/*.eventList .contentEventList { padding: 12px; }*/
</style>